import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'pf-parking-card',
  imports: [TranslocoModule, CommonModule, SharedModule],
  templateUrl: './parking-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './parking-card.component.scss',
})
export class ParkingCardComponent {
  @Output() btnClick = new EventEmitter();
  @Input() parkingCardInfo: any;
  @Input() parkingDetails: any;
  @Input() parkingDays: any;
  @Input() isPreSelected: boolean = false;

  subscription: any;
  locale: string = "";

  constructor(
    private translocoService: TranslocoService
  ) {
    this.subscription = this.translocoService.langChanges$.subscribe((lang) => {
      this.locale = lang;
    });
  }

  onClick() {
    this.btnClick.emit();
  }
}